export const CLEAR_FACEBOOK_AD_TEMPLATES = 'CLEAR_FACEBOOK_AD_TEMPLATES'
export const RESET_ACTIVATION_STATUS = 'RESET_ACTIVATION_STATUS'

export const clearFacebookAdTemplates = () => ({
  type: CLEAR_FACEBOOK_AD_TEMPLATES,
})
export const resetActivationStatus = () => ({ type: RESET_ACTIVATION_STATUS })

export const CREATE_AD_CREATIVE_TEMPLATE = 'CREATE_CREATIVE_TEMPLATE'
export const CREATE_AD_CREATIVE_TEMPLATE_FULFILLED =
  'CREATE_CREATIVE_TEMPLATE_FULFILLED'
export const CREATE_AD_CREATIVE_TEMPLATE_REJECTED =
  'CREATE_CREATIVE_TEMPLATE_REJECTED'

/**
 * Link Information
 * @typedef {object} LinkInformation
 * @property {string} link_type - dynamic or static link
 * @property {string} url - where the link is pointing to
 */
/**
 * Link meta data
 * @typedef {object} MediaData
 * @property {string} source_type - type of source
 * @property {string} souce_id - cloudinary id
 */
/**
 * Creative Meta Data
 * @typedef {object} CreativeMetaData
 * @property {string} message - this is the body of the ad
 * @property {string} name - this is the headline in some placements
 * @property {string} description - this is the description under the link in some placements
 * @property {MediaData} media - cloudinary data for the chosen media
 * @property {LinkInformation} link - link meta data
 */
/**
 * @typedef {object} AdCreativeTemplateData
 * @property {string} brand_id - brand_id
 * @property {string} creative_type - whether the creative uses an image or video
 * @property {CreativeMetaData} creative - The data needed to create the creative
 */
/**
 * @typedef {object} AdCreativeTemplatePayload
 * @property {AdCreativeTemplateData} data - Ad Creative Template Data
 * @property {string} auth - jwt auth
 */
/**
 * Create Ad Creative Template
 * @param {AdCreativeTemplatePayload} payload
 */

export const createAdCreativeTemplate = (payload) => ({
  type: CREATE_AD_CREATIVE_TEMPLATE,
  payload,
})

export const UPDATE_AD_CREATIVE_TEMPLATE = 'UPDATE_CREATIVE_TEMPLATE'
export const UPDATE_AD_CREATIVE_TEMPLATE_FULFILLED =
  'UPDATE_CREATIVE_TEMPLATE_FULFILLED'
export const UPDATE_AD_CREATIVE_TEMPLATE_REJECTED =
  'UPDATE_CREATIVE_TEMPLATE_REJECTED'

/**
 * Link Information
 * @typedef {object} LinkInformation
 * @property {string} link_type - dynamic or static link
 * @property {string} url - where the link is pointing to
 */
/**
 * Link meta data
 * @typedef {object} MediaData
 * @property {string} source_type - type of source
 * @property {string} souce_id - cloudinary id
 */
/**
 * Creative Meta Data
 * @typedef {object} CreativeMetaData
 * @property {string} message - this is the body of the ad
 * @property {string} name - this is the headline in some placements
 * @property {string} description - this is the description under the link in some placements
 * @property {MediaData} media - cloudinary data for the chosen media
 * @property {LinkInformation} link - link meta data
 */
/**
 * @typedef {object} AdCreativeTemplateData
 * @property {string} brand_id - brand_id
 * @property {string} creative_type - whether the creative uses an image or video
 * @property {CreativeMetaData} creative - The data needed to create the creative
 */
/**
 * @typedef {object} AdCreativeTemplatePayload
 * @property {AdCreativeTemplateData} data - Ad Creative Template Data
 * @property {string} [jwt] - jwt auth
 * @property {string} brandId - Brand ID
 * @property {string} adCreativeTemplateId - Ad Creative Template ID
 */
/**
 * Update Ad Creative Template
 * @param {AdCreativeTemplatePayload} payload
 */
export const updateAdCreativeTemplate = (payload) => ({
  type: UPDATE_AD_CREATIVE_TEMPLATE,
  payload,
})

export const CREATE_AD_SET_TEMPLATE = 'CREATE_AD_SET_TEMPLATE'
export const CREATE_AD_SET_TEMPLATE_FULFILLED =
  'CREATE_AD_SET_TEMPLATE_FULFILLED'
export const CREATE_AD_SET_TEMPLATE_REJECTED = 'CREATE_AD_SET_TEMPLATE_REJECTED'

/**
 * @typedef {object} TargetingData
 * @property {string} age_max - maximum age of target audience
 * @property {string} age_min - minimum age of target audience
 * @property {string[]} genders - determines which genders to target
  @property {{id:string, name:string}[]} interests - list of interests to target
 */
/**
 * @typedef {object} AdSetTemplateData
 * @property {string} channel_campaign_id - id of the ad channel
 * @property {TargetingData} creative - The data needed to create the creative
 */
/**
 * @typedef {object} AdSetTemplatePayload
 * @property {AdSetTemplateData} data - Ad Creative Template Data
 * @property {string} auth - jwt auth
 */
/**
 * Create Ad Set Template
 * @param {AdSetTemplatePayload} payload
 */
export const createAdSetTemplate = (payload) => ({
  type: CREATE_AD_SET_TEMPLATE,
  payload,
})

export const UPDATE_AD_SET_TEMPLATE = 'UPDATE_AD_SET_TEMPLATE'
export const UPDATE_AD_SET_TEMPLATE_FULFILLED =
  'UPDATE_AD_SET_TEMPLATE_FULFILLED'
export const UPDATE_AD_SET_TEMPLATE_REJECTED = 'UPDATE_AD_SET_TEMPLATE_REJECTED'

/**
 * @typedef {object} TargetingData
 * @property {string} age_max - maximum age of target audience
 * @property {string} age_min - minimum age of target audience
 * @property {string[]} genders - determines which genders to target
  @property {{id:string, name:string}[]} interests - list of interests to target
 */
/**
 * @typedef {object} AdSetTemplateData
 * @property {string} channel_campaign_id - id of the ad channel
 * @property {TargetingData} creative - The data needed to create the creative
 */
/**
 * @typedef {object} AdSetTemplatePayload
 * @property {AdSetTemplateData} data - Ad Set Template Data
 * @property {string} [jwt] - jwt auth
 * @property {number} brandId - BrandId
 * @property {string} campaignId - Camapign Id
 */
/**
 * Update Ad Set Template
 * @param {AdSetTemplatePayload} payload
 */
export const updateAdSetTemplate = (payload) => ({
  type: UPDATE_AD_SET_TEMPLATE,
  payload,
})

export const CREATE_AD_TEMPLATE = 'CREATE_AD_TEMPLATE'
export const CREATE_AD_TEMPLATE_FULFILLED = 'CREATE_AD_TEMPLATE_FULFILLED'
export const CREATE_AD_TEMPLATE_REJECTED = 'CREATE_AD_TEMPLATE_REJECTED'

/**
 * @typedef {object} AdTemplateData
 * @property {string} creative_template_id - id of the creative template
 * @property {string} adset_template_id - id of the creative template
 */
/**
 * @typedef {object} AdTemplatePayload
 * @property {AdTemplateData} data - Ad Template Data
 * @property {string} auth - jwt auth
 */
/**
 * Create Ad Template
 * @param {AdTemplatePayload} payload
 */
export const createAdTemplate = (payload) => ({
  type: CREATE_AD_TEMPLATE,
  payload,
})

export const GET_CALLS_TO_ACTION = 'GET_CALLS_TO_ACTION'
export const GET_CALLS_TO_ACTION_FULFILLED = 'GET_CALLS_TO_ACTION_FULFILLED'
export const GET_CALLS_TO_ACTION_REJECTED = 'GET_CALLS_TO_ACTION_REJECTED'

/**
 * @typedef {object} GetCallsToActionPayload
 * @property {string} [objective=LINK_CLICKS]
 */
/**
 *
 * @param {GetCallsToActionPayload} payload
 * @returns {{payload: GetCallsToActionPayload, type: string}}
 */
export const getCallsToAction = (payload) => ({
  type: GET_CALLS_TO_ACTION,
  payload,
})

export const GET_CHANNEL_CAMPAIGN = 'GET_CHANNEL_CAMPAIGN'
export const GET_CHANNEL_CAMPAIGN_FULFILLED = 'GET_CHANNEL_CAMPAIGN_FULFILLED'
export const GET_CHANNEL_CAMPAIGN_REJECTED = 'GET_CHANNEL_CAMPAIGN_REJECTED'
/**
 * @typedef {object} GetChannelCampaignPayload
 * @property {number[]} retailerIds - Retailer IDs
 * @property {number} brandId - Brand ID
 * @property {string} channelCampaignId - Channel Campaign Ids
 */
/**
 * Create Ad Template
 * @param {GetChannelCampaignPayload} payload
 */
export const getChannelCampaign = (payload) => ({
  type: GET_CHANNEL_CAMPAIGN,
  payload,
})

export const GET_AD_CREATIVE_TEMPLATE_PREVIEW =
  'GET_AD_CREATIVE_TEMPLATE_PREVIEW'
export const GET_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED =
  'GET_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED'
export const GET_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED =
  'GET_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED'
/**
 * @typedef {object} GetAdCreativeTemplatePreviewPayload
 * @property {string} adCreativeTemplateId - Ad Creative Template Id
 * @property {number[]} retailerIds - Retailer IDs
 * @property {string} facebookPageId - Facebook Page Id
 * @property {string} adType - Valid Facebook ad type
 * @property {number} width - Width
 * @property {number} height - Height
 */
/**
 * Create Ad Template
 * @param {GetAdCreativeTemplatePreviewPayload} payload
 */
export const getAdCreativeTemplatePreview = (payload) => ({
  type: GET_AD_CREATIVE_TEMPLATE_PREVIEW,
  payload,
})

export const POST_AD_CREATIVE_TEMPLATE_PREVIEW =
  'POST_AD_CREATIVE_TEMPLATE_PREVIEW'
export const POST_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED =
  'POST_AD_CREATIVE_TEMPLATE_PREVIEW_FULFILLED'
export const POST_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED =
  'POST_AD_CREATIVE_TEMPLATE_PREVIEW_REJECTED'
/**
 * @typedef {object} PostAdCreativeTemplatePreviewPayload
 * @property {string} adcreative_template_id - Ad Creative Template Id
 * @property {string} retailerId - Retailer ID
 * @property {string} facebookPageId - Facebook Page Id
 * @property {string} url_override - Retailer override url
 * @property {string} call_to_action_override - Retailer CTA override
 * @property {undefined | {
  *  id: string
  *  url_override?: string
  *  call_to_action_override?: string 
  * }[]} child_attachments
/**
 * POST Ad Creative Template Preview
 * @param {PostAdCreativeTemplatePreviewPayload} payload
 */

export const postAdCreativeTemplatePreview = (payload) => ({
  type: POST_AD_CREATIVE_TEMPLATE_PREVIEW,
  payload,
})

export const GET_TARGETING = 'GET_TARGETING'
export const GET_TARGETING_FULFILLED = 'GET_TARGETING_FULFILLED'
export const GET_TARGETING_REJECTED = 'GET_TARGETING_REJECTED'
/**
 * @typedef {object} GetTargetingPayload
 * @property {string} type - Facebook targeting type
 * @property {string[]} fields - OPtional list of fields
 */
/**
 * Create Ad Template
 * @param {GetTargetingPayload} payload
 */
export const getTargeting = (payload) => ({ type: GET_TARGETING, payload })

export const GET_AD_SET_TEMPLATE = 'GET_AD_SET_TEMPLATE'
export const GET_AD_SET_TEMPLATE_FULFILLED = 'GET_AD_SET_TEMPLATE_FULFILLED'
export const GET_AD_SET_TEMPLATE_REJECTED = 'GET_AD_SET_TEMPLATE_REJECTED'
/**
 * @typedef {object} GetAdSetTemplatePayload
 * @property {string} adSetTemplateId - AdSetTemplate id
 * @property {string} retailerId - Optional Retailer ID (retailer or brand is required)
 * @property {string} brandId - Optional Brand ID
 */
/**
 * Create Ad Template
 * @param {GetAdSetTemplatePayload} payload
 */
export const getAdSetTemplate = (payload) => ({
  type: GET_AD_SET_TEMPLATE,
  payload,
})

export const ACTIVATE_CAMPAIGN = 'ACTIVATE_CAMPAIGN'
export const ACTIVATE_CAMPAIGN_FULFILLED = 'ACTIVATE_CAMPAIGN_FULFILLED'
export const ACTIVATE_CAMPAIGN_REJECTED = 'ACTIVATE_CAMPAIGN_REJECTED'
/**
 * @typedef {object} ActivateCampaignPayload
 * @property {number} retailerId
 * @property {string} campaignId
 * @property {string} facebookPageId
 * @property {float} latitude
 * @property {float} longitude
 * @property {number} radius (optional, default = 25)
 * @property {string | undefined | null} businessId
 * @property {object[] | undefined | null} fundingSources
 * @property {undefined | {
 *  url_override?: string
 *  call_to_action_override?: string
 *  child_attachments?: ({
 *    id: string
 *    url_override?: string
 *    call_to_action_override?: string
 *  })[]
 * }} creative
 */
/**
 * Activate Campaign
 * @param {ActivateCampaignPayload} payload
 */
export const activateCampaign = (payload) => ({
  type: ACTIVATE_CAMPAIGN,
  payload,
})

export const CREATE_AD_VIDEO = 'CREATE_AD_VIDEO'
export const CREATE_AD_VIDEO_FULFILLED = 'CREATE_AD_VIDEO_FULFILLED'
export const CREATE_AD_VIDEO_REJECTED = 'CREATE_AD_VIDEO_REJECTED'
/**
 * @typedef {object} CreateAdVideoPayload
 * @property {string} adAccountId
 * @property {number} brandId
 * @property {string} mediaType (default = video)
 * @property {string} sourceType (default = cloudinary)
 * @property {string} sourceId
 */
/**
 * Create Ad Video
 * @param {CreateAdVideoPayload} payload
 */
export const createAdVideo = (payload) => ({
  type: CREATE_AD_VIDEO,
  payload,
})

export const GET_AD_VIDEO = 'GET_AD_VIDEO'
export const GET_AD_VIDEO_FULFILLED = 'GET_AD_VIDEO_FULFILLED'
export const GET_AD_VIDEO_REJECTED = 'GET_AD_VIDEO_REJECTED'
/**
 * @typedef {object} GetAdVideoPayload
 * @property {string} videoId
 * @property {string} brandId
 */
/**
 * Get Ad Video
 * @param {GetAdVideoPayload} payload
 */
export const getAdVideo = (payload) => ({
  type: GET_AD_VIDEO,
  payload,
})

export const SUBSCRIBE_TO_AD_VIDEO = 'SUBSCRIBE_TO_AD_VIDEO'
export const UNSUBSCRIBE_FROM_AD_VIDEO = 'UNSUBSCRIBE_FROM_AD_VIDEO'

export const PUSHER_EVENT_AD_VIDEO_PROCESSING =
  'PUSHER_EVENT_AD_VIDEO_PROCESSING'

export const PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_START =
  'PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_START'
/**
 * @typedef {object} PusherEventAdVideoProcessingTimerStartPayload
 * @property {string} videoId
 * @property {string} brandId
 * @property {string} channelId
 * @property {string} eventId
 */
/**
 * Pusher Event Ad Video Processing Timer Start
 * @param {PusherEventAdVideoProcessingTimerStart} payload
 */
export const pusherEventAdVideoProcessingTimerStart = (payload) => ({
  type: PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_START,
  payload,
})

export const PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_CANCEL =
  'PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_CANCEL'
/**
 * @typedef {object} PusherEventAdVideoProcessingTimerCancelPayload
 * @property {string} channelId
 * @property {string} eventId
 */
/**
 * Pusher Event Ad Video Processing Timer Cancel
 * @param {PusherEventAdVideoProcessingTimerCancel} payload
 */
export const pusherEventAdVideoProcessingTimerCancel = (payload) => ({
  type: PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_CANCEL,
  payload,
})

export const PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_ERROR =
  'PUSHER_EVENT_AD_VIDEO_PROCESSING_TIMER_ERROR'

export const GET_RETAILER_AD_CREATIVE_TEMPLATE =
  'GET_RETAILER_AD_CREATIVE_TEMPLATE'
export const GET_RETAILER_AD_CREATIVE_TEMPLATE_FULFILLED =
  'GET_RETAILER_AD_CREATIVE_TEMPLATE_FULFILLED'
export const GET_RETAILER_AD_CREATIVE_TEMPLATE_REJECTED =
  'GET_RETAILER_AD_CREATIVE_TEMPLATE_REJECTED'

/**
 * @param {{
 *  id: string
 *  retailerId: number
 *  facebookPageId?: number
 * }} payload
 */
export const getRetailerAdCreativeTemplate = (payload) => ({
  type: GET_RETAILER_AD_CREATIVE_TEMPLATE,
  payload,
})
